import cn from 'classnames';
import type { ReactNode } from 'react';
import { Flex, type MenuItemType } from 'ui';
import type { MessageDirection } from '../../../types';
import { ChatMessageActionsDropdown } from './chat-message-actions-dropdown';

type P = {
  children: ReactNode;
  direction: MessageDirection;
  items: MenuItemType[];
};

const ChatMessageActions = ({ children, direction, items }: P): ReactNode => {
  if (items.length === 0) {
    return children;
  }

  return (
    <Flex align="center" className="chat-message-actions" gap="xxxs">
      {direction === 'incoming' ? (
        <>
          {children}
          <ChatMessageActionsDropdown
            className={(isOpen) => cn('chat-message-actions__btn', { 'chat-message-actions__btn--open': isOpen })}
            direction={direction}
            items={items}
          />
        </>
      ) : (
        <>
          <ChatMessageActionsDropdown
            className={(isOpen) => cn('chat-message-actions__btn', { 'chat-message-actions__btn--open': isOpen })}
            direction={direction}
            items={items}
          />
          {children}
        </>
      )}
    </Flex>
  );
};

export default ChatMessageActions;
